module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.shown) ? _c('div', [_c('div', {
    staticClass: "modal-backdrop in"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal dynamic in",
    staticStyle: {
      "display": "block"
    }
  }, [(_vm.shown) ? _c('div', {
    staticClass: "modal-dialog modal-lg ui-draggable"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header ui-draggable-handle"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Close")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Opdater status")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "0px 15px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.status_types), function(status_type, id) {
    return _c('div', {
      staticClass: "col-md-6",
      staticStyle: {
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "btn btn-lg btn-block",
      class: [_vm.status_class(status_type.statustype), {
        active: (status_type.statustype === _vm.employee.status.status)
      }],
      staticStyle: {
        "position": "relative",
        "font-size": "2em"
      },
      on: {
        "click": function($event) {
          _vm.set_status(status_type.statustype)
        }
      }
    }, [(_vm.status_active(_vm.employee.status.status, status_type.statustype)) ? _c('i', {
      staticClass: "fa fa-lg fa-check",
      staticStyle: {
        "position": "absolute",
        "top": ".5em",
        "left": ".5em"
      }
    }) : _vm._e(), _vm._v(_vm._s(status_type.navn) + "\n\t\t\t\t\t\t\t\t\t")])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "onclick": "return false;"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Annullér")])])])]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1850fdc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./public_html/scripts/vue-components/status-picker.vue
// module id = 20
// module chunks = 0